import { FormikProps } from "formik";
import CustomTextArea from "../../../../../../../../../../../../components/CustomTextArea";
import Flex from "../../../../../../../../../../../../components/Flex";
import StyledButtonV2 from "../../../../../../../../../../../../components/app/StyledButtonV2";
import StyledFormModal from "../../../../../../../../../../../../components/globalModal/StyledModal";
import { DisclosureHost } from "../../../../../../../../../../../../hooks/use-disclosure";
import useFormDraft from "../../../../../../../../../../../../hooks/use-form-draft";
import { Form2Payload } from "../../../../../../../../../scheduling/appointment/encounter/encounter-constant";
import CheckboxCardSections from "../../InitialPsychotherapy/CheckboxCardSections";
import {
  DAP_INTERVENTIONS_FIELDS,
  DAP_INTERVENTIONS_SECTIONS,
  OTHER_INTERVENTIONS_NOTE_KEY,
  OTHER_THERAPEUTIC_INTERVENTIONS,
} from "../DapNoteConstant";

interface InterventionsProvidedModalProps {
  disclosureHost: DisclosureHost;
  formik: FormikProps<Form2Payload>;
}

const InterventionsProvidedModal = ({
  disclosureHost,
  formik,
}: InterventionsProvidedModalProps) => {
  // Edits stay in the draft until Save, so the note behind the modal is
  // untouched while the user is still filling it in — same flow as the MSE modal.
  const draft = useFormDraft(
    formik,
    DAP_INTERVENTIONS_FIELDS,
    disclosureHost.opened
  );

  const selected = (draft.values?.interventionsProvided ?? "")
    .split(",")
    .filter(Boolean);

  const handleSave = () => {
    draft.save();
    disclosureHost.close();
  };

  return (
    <StyledFormModal
      open={disclosureHost.opened}
      onClose={() => disclosureHost.close()}
      dialogTitle="Interventions Provided"
      dialogAction={
        <>
          <StyledButtonV2
            label="Cancel"
            variant="outlined"
            onClick={() => disclosureHost.close()}
          />
          <StyledButtonV2
            label="Save"
            variant="contained"
            onClick={handleSave}
            sx={{ width: "105px" }}
          />
        </>
      }
      sx={{
        "& .MuiDialog-paper": {
          width: "60vw",
          height: "70vh",
        },
      }}
    >
      <Flex flexDirection="column" gap={2} width="100%" height="100%" pt={2}>
        <CheckboxCardSections
          formik={draft}
          sections={DAP_INTERVENTIONS_SECTIONS}
        />

        {selected.includes(OTHER_THERAPEUTIC_INTERVENTIONS) && (
          <CustomTextArea
            label="Other Therapeutic Interventions"
            name={OTHER_INTERVENTIONS_NOTE_KEY}
            placeholder="Describe the other therapeutic interventions provided..."
            value={draft.values?.otherTherapeuticInterventionsNote || ""}
            onChange={draft.handleChange}
            minRows={3}
          />
        )}
      </Flex>
    </StyledFormModal>
  );
};

export default InterventionsProvidedModal;
